export var getActiveCalculatorId = function getActiveCalculatorId(state) {
  return state.getIn(['ui', 'activeCalculatorId'], null);
};